<div class="header-bar">
  <div class="header-left"></div>
  <div class="header-center">
    {{ newBeaconRegion ? "Create New Beacon Region" : "Beacon Region" }}
  </div>
  <div *ngIf="newBeaconRegion" class="header-right">
    <button mat-button color="fiord" (click)="cancel()">Cancel</button>
    <button
      mat-button
      color="lightGreen"
      (click)="saveNewBeaconRegion()"
      [disabled]="saveDisabled"
    >
      Save New Beacon
    </button>
  </div>
  <div *ngIf="!newBeaconRegion" class="header-right">
    <button
      *ngIf="showDelete"
      mat-button
      color="warn"
      (click)="deleteBeaconRegion()"
    >
      Delete Beacon Region
    </button>
    <button
      mat-button
      color="lightGreen"
      (click)="saveBeaconRegionUpdates()"
      [disabled]="saveDisabled"
    >
      Save Beacon Region Updates
    </button>
  </div>
</div>
<div class="beacon-region">
  <div class="containers">
    <div class="container beacon-region-details-container">
      <div class="container-header no-bottom-border">
        <div class="text">Beacon Region Details</div>
      </div>
      <div class="container-content">
        <div class="container-row">
          <lhpe-input
            class="input"
            controlName="name"
            placeholder="Beacon Region Name"
            [formGroup]="beaconRegionForm!"
            [required]="true"
          >
          </lhpe-input>
        </div>

        <div class="container-row">
          <lhpe-input
            class="input"
            controlName="entry_delay_seconds"
            placeholder="Entry Delay (seconds)"
            [formGroup]="beaconRegionForm!"
            [required]="true"
          >
          </lhpe-input>
        </div>

        <div class="container-row">
          <lhpe-input
            class="input"
            controlName="timeout"
            placeholder="Timeout (seconds)"
            [formGroup]="beaconRegionForm!"
            [required]="true"
          >
          </lhpe-input>
        </div>

        <div class="container-row">
          <mat-form-field class="tag-chip-list">
            <mat-label>Tags</mat-label>
            <mat-chip-list #chipList aria-label="Tags">
              <mat-chip
                *ngFor="let tag of beaconRegionForm.controls.tags.value"
                (removed)="removeTag(tag)"
              >
                {{ tag }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
              <input
                placeholder="New tag..."
                [matChipInputFor]="chipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="true"
                (matChipInputTokenEnd)="addTag($event)"
              />
            </mat-chip-list>
          </mat-form-field>
        </div>

        <div class="container-row" [formGroup]="beaconRegionForm!">
          <mat-slide-toggle formControlName="disabled"
            >Disabled</mat-slide-toggle
          >
        </div>

        <div class="container-row" *ngIf="!newBeaconRegion">
          <div class="input-box">
            <mat-form-field>
              <mat-label>UID</mat-label>
              <input matInput value="{{ beaconRegion?.uid }}" disabled />
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>

    <div class="container settings-container">
      <div>
        <div class="container-header no-bottom-border">
          <div class="text">Broadcast Settings</div>
        </div>
        <div class="container-content">
          <mat-tab-group>
            <mat-tab label="iBeacon">
              <div class="container-row">
                <lhpe-input
                  class="input"
                  controlName="uuid"
                  placeholder="UUID"
                  [formGroup]="beaconRegionForm!"
                >
                </lhpe-input>
              </div>

              <div class="container-row">
                <lhpe-input
                  class="input"
                  controlName="major"
                  placeholder="Major"
                  type="number"
                  [formGroup]="beaconRegionForm!"
                >
                </lhpe-input>
              </div>

              <div class="container-row">
                <lhpe-input
                  class="input"
                  controlName="minor"
                  placeholder="Minor"
                  type="number"
                  [formGroup]="beaconRegionForm!"
                >
                </lhpe-input>
              </div>
            </mat-tab>
            <mat-tab label="Proximity">
              <div class="container-row">
                <lhpe-input
                  class="input"
                  controlName="proximity_tag"
                  placeholder="Tag"
                  [formGroup]="beaconRegionForm!"
                >
                </lhpe-input>
              </div>

              <div class="container-row">
                <lhpe-input
                  class="input"
                  controlName="proximity_range"
                  placeholder="Range"
                  [formGroup]="beaconRegionForm!"
                >
                </lhpe-input>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </div>

    <div *ngIf="!newBeaconRegion" class="beacons-container" cdkDropListGroup>
      <div class="container">
        <div class="container-header no-bottom-border">
          <div class="text">Available Beacons - drag to assign</div>
        </div>
        <div class="container-content">
          <div class="unassigned-beacons">
            <div class="beacon-name">
              <div class="input-box">
                <input
                  class="input"
                  [(ngModel)]="beaconSearchText"
                  placeholder="Search"
                />
              </div>
            </div>
            <div class="drop">
              <mat-chip-list
                #chipList
                aria-label="Beacon selection"
                cdkDropList
                (cdkDropListDropped)="onDropBeacon($event)"
                [cdkDropListData]="{
                  list: 'unassigned',
                  obj: unassignedBeacons
                }"
              >
                <mat-chip
                  *ngFor="
                    let beacon of unassignedBeacons
                      | beaconFilter: beaconSearchText;
                    let bi = index
                  "
                  cdkDrag
                  [cdkDragData]="beacon"
                >
                  {{ beacon.name }}
                </mat-chip>
              </mat-chip-list>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="container-header no-bottom-border">
          <div class="text">Assigned Beacons</div>
        </div>
        <div class="container-content">
          <div class="assigned-beacons">
            <div class="drop">
              <mat-chip-list
                #chipList
                aria-label="Region selection"
                cdkDropList
                (cdkDropListDropped)="onDropBeacon($event)"
                [cdkDropListData]="{ list: 'assigned' }"
              >
                <mat-chip
                  selected
                  *ngFor="let beacon of beaconRegion!.beacons!; let ri = index"
                  cdkDrag
                  [cdkDragData]="beacon"
                  (removed)="onBeaconRemove(beacon)"
                >
                  {{ beacon.name }}
                  <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip>
              </mat-chip-list>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
